import { Suspense, lazy, useContext, useEffect, useState } from "react";
import LoginContext from "../../store/login/LoginContext";
import StudyContext from "../../store/studyRoom/StudyContext";
import Selections from "./selections/Selections";
import ShareUs from "../startPage/shareUs/ShareUs";
import styles from "./Styles.module.css";
import { trackEvent, trackPageView } from "../../utils/analytics";

const TestPaper = lazy(() => import("./testPaper/TestPaper"));
const PerformanceRecord = lazy(() => import("./performanceRecord/PerformanceRecord"));

const StudyRoom = (props) => {
    const loginCtx = useContext(LoginContext);
    const user = loginCtx.user;
    const method = loginCtx.method;
    const [showNav, setShowNav] = useState(true);
    const [showSelections, setShowSelections] = useState(false);
    const [showTestPaper, setShowTestPaper] = useState(false);
    const [showPerformance, setShowPerformance] = useState(false);

    const [grade, setGrade] = useState();
    const [selectedSubject, setSelectedSubject] = useState();
    const [selectedType, setSelectedType] = useState();
    const [listOfTestPapers, setListOfTestPapers] = useState();
    const [selectedTestPaper, setSelectedTestPaper] = useState();
    const [selectedTestPaperId, setSelectedTestPaperId] = useState();
    const [selectedTestLevel, setSelectedTestLevel] = useState();
    const [testDocument, setTestDocument] = useState();

    useEffect(() => {
      if (showTestPaper) {
        trackPageView("/app/study-room/test-paper", "Test Paper | Exambridge");
        return;
      }
      if (showSelections) {
        trackPageView("/app/study-room/select-paper", "Select Test Paper | Exambridge");
        return;
      }
      if (showPerformance) {
        trackPageView("/app/study-room/performance", "Performance | Exambridge");
        return;
      }
      if (showNav) {
        trackPageView("/app/study-room", "Study Room | Exambridge");
      }
    }, [showNav, showSelections, showTestPaper, showPerformance]);

    const restartHandler = () => {
      setShowNav(true);
      setShowSelections(false);
      setShowTestPaper(false);
      setShowPerformance(false);
    };

    const showSelectionsHandler = () => {
      setShowNav(false);
      setShowSelections(true);
      setShowTestPaper(false);
      setShowPerformance(false);
    };

    const showTestPaperHandler = (
      grade, selectedSubject, selectedType, listOfTestPapers, selectedTestPaper, selectedTestLevel) => {
      console.log("SR props data: ", {
        grade,
        selectedSubject,
        selectedType,
        listOfTestPapers,
        selectedTestPaper,
      });
      setGrade(grade);
      setSelectedSubject(selectedSubject);
      setSelectedType(selectedType);
      setListOfTestPapers(listOfTestPapers);
      setSelectedTestPaper(selectedTestPaper);
      setSelectedTestLevel(selectedTestLevel);
      trackEvent("test_start", {
        level: grade,
        subject: selectedSubject,
        paper_type: selectedType,
        test_level: selectedTestLevel,
      });
      setShowSelections(false);
      setShowTestPaper(true);
      setShowPerformance(false);
    };

    const selectAnotherPaperHandler = () => {
      setShowNav(true);
      setShowSelections(false);
      setShowTestPaper(false);
      setShowPerformance(false);
    };

    const showPerformanceHandler = () => {
      setShowNav(false);
      setShowSelections(false);
      setShowTestPaper(false);
      setShowPerformance(true);
    };

    const [progress, setProgress] = useState();
    const [question, setQuestion] = useState();

    const handleLogout = () => {
      const isConfirmed = confirm("Do you really want to log out");
      if (isConfirmed) props.onLogout();
    };

    const ctxData = {
      grade,
      selectedSubject,
      selectedType,
      listOfTestPapers,
      selectedTestPaper,
      selectedTestPaperId,
      selectedTestLevel,
      progress,
      question,
      testDocument,
      onCloseTestPaper: restartHandler,
      onShowSelectionsHandler: showSelectionsHandler,
    };

    return (
      <StudyContext.Provider value={ctxData}>
        {showNav && (
          <div className={styles.classes}>
            <header>
              <h2>Study Room</h2>
              <p>{loginCtx.callname}, welcome to your study room</p>
            </header>
            <div className={styles.btnDiv}>
              <button
                className={styles.bgGreen}
                type="button"
                onClick={showSelectionsHandler}
              >
                Select test paper
              </button>
              {user !== "guest" && (
                <>
                  <button
                    className={styles.bgBlue}
                    type="button"
                    onClick={showPerformanceHandler}
                  >
                    Performance
                  </button>
                </>
              )}
              {user !== "guest" &&
                method !== "google" &&
                method !== "facebook" &&
                method !== "microsoft" && (
                  <>
                    <button
                      className={styles.bgPurple}
                      type="button"
                      onClick={props.onCloseStudyRoom}
                    >
                      Personal data update
                    </button>
                  </>
                )}
              <button
                className={styles.bgRed}
                type="button"
                onClick={handleLogout}
              >
                Sign out
              </button>
            </div>
            {/* <ShareUs /> */}
          </div>
        )}
        {showSelections && (
          <Selections
            onShowTestPaper={showTestPaperHandler}
            onCancel={restartHandler}
            onLogout={props.onLogout}
            onShowPerformance={showPerformanceHandler}
          />
        )}
        {showTestPaper && (
          <Suspense fallback={<p>loading your performance record ...</p>}>
            <TestPaper
              onSelectAnotherPaper={selectAnotherPaperHandler}
              onShowPerformance={showPerformanceHandler}
              onReset={restartHandler}
              onLogout={props.onLogout}
            />
          </Suspense>
        )}
        {showPerformance && user !== "guest" && (
          <Suspense fallback={<p>loading your performance record ...</p>}>
            <PerformanceRecord
              onSelectAnotherPaper={selectAnotherPaperHandler}
              onClose={selectAnotherPaperHandler}
            />
          </Suspense>
        )}
      </StudyContext.Provider>
    );
};

export default StudyRoom;